// extracted by mini-css-extract-plugin
export default {"workspace":"workspace_workspace__OvF3W"};